var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagnoses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3783 7.05559V9.1658H8.75965V7.05559H7V24H22.1379V7.05559H20.3783ZM10.5179 19.7211H9.34516V18.6664H10.5179V19.7211ZM10.5179 17.2582H9.34516V16.2035H10.5179V17.2582ZM10.5179 14.7953H9.34516V13.7406H10.5179V14.7953ZM10.5179 12.3324H9.34516V11.2777H10.5179V12.3324ZM19.7927 19.7211H11.6907V18.6664H19.7927V19.7211ZM19.7927 17.2582H11.6907V16.2035H19.7927V17.2582ZM19.7927 14.7953H11.6907V13.7406H19.7927V14.7953ZM19.7927 12.3324H11.6907V11.2777H19.7927V12.3324Z",
    id: "icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2065 6H9.93146V8.11113H19.2065V6Z",
    id: "icon"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnoses);
export default __webpack_public_path__ + "static/media/diagnoses.921a4eb8.svg";
export { ForwardRef as ReactComponent };